(function() {

    var shipping = '.js-customer-chooses-shipping';
    var $shipping = $(shipping);

    var customsAgreement = '.js-customs-agreement';
    var $customsAgreement = $(customsAgreement);

    var form = '#js-delivery-option-form';
    var $form = $(form);

    var $submitBtn = $(_ajaxParams.submitBtn);

    var requiredFieldGroup = '.js-field-validation';
    var $requiredFieldGroup = $(requiredFieldGroup);

    var requiredField = '.js-field-validation__field';
    var $requiredField = $(requiredField);

    var params = {
        dataErrorMsg: 'error-msg',
        hasErrorClass: 'c-form-validation--error',
        errorNotice: 'js-form-validation__msg',
        errorNoticeHtml: '<p class="c-form-validation__msg"></p>'
    };

    //	======================================================================  //
    //	Functions
    //	======================================================================  //

    /**
     * @function `disableSubmitIfNeeded`
     *
     * Disables the submit button if the required fields are not filled properly
     * to submit the form without any error.
     */
    function disableSubmitIfNeeded() {
        if( !$submitBtn.length ) {
            return;
        }
        if( !$shipping.prop('checked') ) {
            return;
        }
        else {
            if( !$customsAgreement.length ) {
                return;
            }
        }
        _disableSubmit( $submitBtn );
    }

    /**
     * @function `validation`
     *
     * Prevents form submission if customer chooses shipping but does not agree to
     * the international customs policy.
     *
     * @param e (event) - the submit event
     *
     * 1. Quick escape if there's no customs agreement for the target country.
     */
    function validation( e ) {
        if( $shipping.prop('checked') ) {
            if( !$customsAgreement.length ) { /* [1] */
                return;
            }
            else if( !$customsAgreement.prop('checked') ) {
                e.preventDefault();
                if( $requiredFieldGroup.hasClass(params.hasErrorClass) ) {
                    return;
                }
                $requiredFieldGroup.addClass(params.hasErrorClass);
                var $errorNotice = $(params.errorNoticeHtml);
                $errorNotice.html($requiredFieldGroup.data(params.dataErrorMsg))
                    .addClass(params.errorNotice);
                $errorNotice.insertAfter( $requiredField );
            }
        }
    }

    //    ==================================================================  //
    //    On ready
    //    ==================================================================  //

    onReady.callbacks.checkoutCustomsAgreement = disableSubmitIfNeeded;

    //	======================================================================  //
    //	On submission
    //	======================================================================  //

    $form.on('submit', function(e) {
        validation(e);
    });

    //  ======================================================================  //
    //  On change
    //  ======================================================================  //

    _$document.on('change', form, function() {
        var $groupWithError =
            $customsAgreement.closest(requiredFieldGroup+'.'+params.hasErrorClass);
        if( $shipping.prop('checked') ) {
            if( !$customsAgreement.length ) {
                return;
            }
            else if( !$customsAgreement.prop('checked') ) {
                _disableSubmit( $submitBtn );
            }
            else {
                _enableSubmit( $submitBtn );
            }
        }
        else {
            _enableSubmit( $submitBtn );
        }
        if( !$groupWithError.length ) {
            return;
        }
        $groupWithError.find('.'+params.errorNotice).remove()
            .removeClass(params.hasErrorClass);
    });

})();
